import styled from 'styled-components';
import { getSpace, mq, px2rem, getGridSpan } from '../../../stylesheets/tools';

const StyledLandingTeaser = styled.section`
  padding: ${getSpace('xxxl')} 0 0 0;

  .landing-teaser__headline {
    margin-bottom: ${getSpace('l')} ${mq('m')} {
      margin-bottom: ${getSpace('xxxl')};
    }
  }

  .landing-teaser__grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    ${mq('m')} {
      padding-bottom: 180px;
    }
  }

  .landing-teaser__item {
    margin-bottom: ${getSpace('xl')};
  }

  .landing-teaser__item:nth-child(2n) {
    ${mq('m')} {
      transform: translateY(${px2rem('180px')});
    }
  }

  .landing-teaser__more {
    ${mq('m')} {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-right: 20px;
      width: ${getGridSpan(6)};
    }

    .landing-teaser__link {
      font-size: 30px;
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 12px;

      ${mq('m')} {
        font-size: 36px;
      }

      svg {
        height: 16px;
        width: auto;
      }
    }
  }
`;

export default StyledLandingTeaser;
